import React from 'react'
import { Link } from 'react-router-dom'
import logo from  '../../img/logo.png'
export default function Navbar() {
    return <>
        <div className="container-fluid header position-relative overflow-hidden p-0 w-100 ">

            <nav className=" w-100 navbar navbar-expand-lg bg-primary navbar-dark shadow-sm py-3 py-lg-0 px-3 px-lg-5 fixed-top">
                <Link to="/" className="navbar-brand p-0">
                <img src={logo} alt="" width={80} /> 
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto py-0">
                        <Link to="/" className="nav-item nav-link ">Home</Link>
                        <Link to="/about" className="nav-item nav-link">About</Link>
                        <Link to="/story" className="nav-item nav-link">our story</Link>
                        <Link to="/fresh-products" className="nav-item nav-link">Fresh Products</Link>
                        <Link to="/frozen-products" className="nav-item nav-link">frozen Products</Link>
                        <Link to="" className="nav-item nav-link">exhibition</Link>
                        <Link to="" className="nav-item nav-link">certificates</Link>
                        <Link to="/contact" className="nav-item nav-link">Contact Us</Link>
                    </div>
                </div>
            </nav>
        </div>
    </>
}
